/*
 * Terms and conditions approval for the cart.
 *
 * Blocks the checkout button in the cart drawer and on the cart page until the
 * shopper ticks the approval checkbox rendered by snippets/cart-terms.liquid.
 * The choice is kept for the browsing session so that re-rendering the cart
 * (quantity change, add to cart) does not silently reset it.
 */
(function () {
  if (window.bbCartTerms) return;

  var STORAGE_KEY = 'bb:cart-terms-accepted';
  var SELECTORS = {
    block: '[data-cart-terms]',
    checkbox: '[data-cart-terms-checkbox]',
    error: '[data-cart-terms-error]',
    guard: '[data-cart-terms-guard]',
    checkout: '[name="checkout"]',
  };

  function readAccepted() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeAccepted(value) {
    try {
      if (value) {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      // Storage unavailable (private mode): the in-memory state still applies.
    }
  }

  var accepted = readAccepted();

  /*
   * Finds the approval block that belongs to the given element by walking up its
   * ancestors, stopping before <body> so that a checkout button living outside of
   * a cart that has an approval block (e.g. the cart notification) is left alone.
   */
  function findBlock(element) {
    var node = element;

    while (node && node !== document.body) {
      if (node.querySelector) {
        var block = node.querySelector(SELECTORS.block);
        if (block) return block;
      }
      node = node.parentElement;
    }

    return null;
  }

  function hideError(block) {
    var error = block.querySelector(SELECTORS.error);
    block.classList.remove('bb-cart-terms--error');
    if (error) error.hidden = true;
  }

  function showError(block) {
    if (!block) return;

    var error = block.querySelector(SELECTORS.error);
    var checkbox = block.querySelector(SELECTORS.checkbox);

    block.classList.add('bb-cart-terms--error');
    if (error) error.hidden = false;

    if (checkbox) {
      if (block.scrollIntoView) block.scrollIntoView({ block: 'nearest' });
      checkbox.focus({ preventScroll: true });
    }
  }

  function sync() {
    document.querySelectorAll(SELECTORS.block).forEach(function (block) {
      var checkbox = block.querySelector(SELECTORS.checkbox);
      if (checkbox && checkbox.checked !== accepted) checkbox.checked = accepted;
      if (accepted) hideError(block);
    });

    document.querySelectorAll(SELECTORS.guard).forEach(function (guard) {
      guard.hidden = accepted;
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var checkbox = target.closest(SELECTORS.checkbox);
    if (!checkbox) return;

    accepted = checkbox.checked;
    writeAccepted(accepted);
    sync();
  });

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var guard = target.closest(SELECTORS.guard);
      if (guard) {
        event.preventDefault();
        event.stopPropagation();
        showError(findBlock(guard));
        return;
      }

      if (accepted) return;

      var checkout = target.closest(SELECTORS.checkout);
      if (!checkout) return;

      var block = findBlock(checkout);
      if (!block) return;

      event.preventDefault();
      event.stopPropagation();
      showError(block);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (accepted) return;

      var form = event.target;
      if (!form || !form.elements || !form.elements.namedItem) return;

      // The checkout buttons sit outside of their form and are tied to it with
      // a form attribute, so go through form.elements rather than the subtree.
      var checkout = form.elements.namedItem('checkout');
      if (checkout && checkout.length && !checkout.tagName) checkout = checkout[0];
      if (!checkout) return;

      var block = findBlock(checkout);
      if (!block) return;

      event.preventDefault();
      showError(block);
    },
    true
  );

  /*
   * The drawer and the cart summary are re-rendered from the server after every
   * cart update, which brings back a fresh (unchecked) checkbox — put the
   * session choice back on it.
   */
  var syncScheduled = false;
  var observer = new MutationObserver(function () {
    if (syncScheduled) return;
    syncScheduled = true;
    setTimeout(function () {
      syncScheduled = false;
      sync();
    }, 0);
  });

  function init() {
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.bbCartTerms = {
    get accepted() {
      return accepted;
    },
    sync: sync,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
